import React, { Fragment, useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { createNote } from '../../../common/api';
import { toast } from 'react-toastify';
import TFVideoRecorder from '../RecordVideo';
import TFAudioRecorder from '../../Recorder/audio';
import PersonalVideoIcon from '@mui/icons-material/PersonalVideo';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import MicIcon from '@mui/icons-material/Mic';
import VideocamIcon from '@mui/icons-material/Videocam';
import { storeMedia, createId } from '../../../common/utils';

import '../modals.css';

const AddNote = ( { close, aid, uid, cid, lid } ) => {
    const [ desc, setDesc ] = useState( '' );
    const [ detailsFormat, setDetailsFormat ] = useState( 'text' );
    const [ details, setDetails ] = useState( '' );
    const [ ready, setReady ] = useState( false );
    const [ processing, setProcessing ] = useState( false );

    const [ showVideo, setShowVideo ] = useState( false );
    const [ videoFormat, setVideoFormat ] = useState();

    const [ audioBlob, setAudioBlob ] = useState(null);
    const [ videoBlob, setVideoBlob ] = useState(null);
    const refVideo = useRef( null );
    const refThumb = useRef( null );

    const recorderRef = useRef( null );
    
    useEffect( () => {
        if ( desc && desc.length > 0 ) {
            setReady( true );
        } else {
            setReady( false );
        }
    }, [ desc ] );

    const create = async () => {
        setProcessing( true );
        
        let mediaUrl;
        if ( detailsFormat === 'audio' ) {
            mediaUrl = await storeMedia( aid, uid, createId( 'aud' ) + '.mkv', audioBlob, 'video/x-matroska' );
        } else if ( detailsFormat === 'video' ) {
            mediaUrl = await storeMedia( aid, uid, createId( 'vid' ) + '.mkv', videoBlob, 'video/x-matroska' );
        }

        const note = {
            name: desc,
            details: details,
            audio: ( detailsFormat === 'audio' ),
            video: ( detailsFormat === 'video' ),
            mediaUrl: mediaUrl
        };
        const added = await createNote( aid, uid, note, [ cid ], lid );
        if ( added.length ) {
            toast.success( `The Note has been added`, { theme: 'dark' } );
            close();
        }
    }

    const launchRecorder = ( type ) => {
        setVideoFormat( type );
        setShowVideo( true );
    }

    const capture = () => {
        const ctx = refThumb.current.getContext( '2d' );
        ctx.drawImage( refVideo.current, 0, 0, 200, 150 );
        const img = refThumb.current.toDataURL( 'image/png' );
        console.log( 'img', img );
        refVideo.current.poster = img;
    }

    useEffect( () => {
        if ( videoBlob ) {
            refVideo.current.src = URL.createObjectURL( videoBlob );
        }
    }, [ videoBlob ] );

    useEffect( () => {
        if ( refVideo?.current?.src ) {
            capture();
        }
    }, [ refVideo ] );

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '550px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Record a Note</Col>
                </Row>
                {
                    processing ? (
                        <Fragment>
                            <Row className='py-3'>
                                <Col className='text-center'>
                                    <Spinner animation="border" variant='primary' role="status" />
                                </Col>
                            </Row>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Row className='py-3'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Brief Description of the Note</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type="text" placeholder="Enter a description" value={desc} onChange={ ( e ) => setDesc( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-1 align-items-center'>
                                <Col xs='auto'>
                                    How do you want to log this?
                                </Col>
                                <Col xs='auto'>
                                    <Button variant='link' size='sm' style={ { color: ( detailsFormat === 'text' ) ? 'var( --tf-orange )' : '#000' } } onClick={ () => setDetailsFormat( 'text' ) }>
                                        <KeyboardIcon />
                                    </Button>    
                                </Col>
                                <Col xs='auto'>
                                    <Button variant='link' size='sm' style={ { color: ( detailsFormat === 'audio' ) ? 'var( --tf-orange )' : '#000' } } onClick={ () => setDetailsFormat( 'audio' ) }>
                                        <MicIcon />
                                    </Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button variant='link' size='sm' style={ { color: ( detailsFormat === 'video' ) ? 'var( --tf-orange )' : '#000' } } onClick={ () => setDetailsFormat( 'video' ) }>
                                        <VideocamIcon />
                                    </Button>
                                </Col>
                            </Row>
                            {
                                ( detailsFormat === 'text' ) ? (
                                    <Row className='py-3'>
                                        <Col>
                                            <Form.Group>
                                                {/* <Form.Label>Details of the {commType}</Form.Label> */}
                                                <Form.Control className='tf-modal-text-input' as="textarea" rows={3} placeholder="Details..." value={details} onChange={ ( e ) => setDetails( e.target.value ) } />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                ) : (
                                    null
                                )
                            }
                            {
                                ( detailsFormat === 'audio' ) ? (
                                    <Fragment>
                                        <Row className='py-3 justify-content-center'>
                                            <Col>
                                                <TFAudioRecorder setBlob={setAudioBlob} />
                                            </Col>
                                        </Row>
                                    </Fragment>
                                ) : (
                                    null
                                )
                            }
                            {
                                ( detailsFormat === 'video' ) ? (
                                    <Fragment>
                                        <Row className='py-3 justify-content-center'>
                                            <Col xs='auto'>
                                                <Button variant='outline-primary' onClick={ () => launchRecorder( 'face' ) }>
                                                    <AccountBoxIcon />
                                                    <div className='pt-1' style={{fontSize: '10px'}}>Face Only</div>
                                                </Button>    
                                            </Col>
                                            <Col xs='auto'>
                                                <Button variant='outline-primary' disabled>
                                                    <PersonalVideoIcon />
                                                    <div className='pt-1' style={{fontSize: '10px'}}>Screen Only <br />(coming soon)</div>
                                                </Button>
                                            </Col>
                                            <Col xs='auto'>
                                                <Button variant='outline-primary' disabled>
                                                    <AccountBoxIcon />
                                                    <div className='pt-1' style={{fontSize: '10px'}}>Face & Screen<br />(coming soon)</div>
                                                </Button>    
                                            </Col>
                                        </Row>
                                        <Row className='py-3 justify-content-center'>
                                            <Col>
                                                {
                                                    ( videoBlob ) ? (
                                                        <Fragment>
                                                            <Row>
                                                                <Col>
                                                                    <video id='tf-video' controls autoPlay playsInline ref={refVideo} style={ { width: '400px' } }></video>    
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    <Button onClick={capture}>Create Thumbnail</Button>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    <canvas width={200} height={150} id='tf-thumbnail' ref={refThumb}></canvas>
                                                                </Col>
                                                            </Row>
                                                        </Fragment>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                            </Col>
                                        </Row>
                                    </Fragment>
                                ) : (
                                    null
                                )
                            }
                            <Row className='py-3'>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => create() } disabled={!ready}>Save</Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                </Col>
                            </Row>
                            <Modal open={showVideo} onClose={ () => setShowVideo( false ) }>
                                <TFVideoRecorder vidType={ videoFormat } setBlob={ setVideoBlob } close={ () => setShowVideo( false ) } />
                            </Modal>
                        </Fragment>
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    // aid: state.user.aid,
    uid: state.user.email,
    // cid: state.contacts.currentId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( AddNote );